import { useQuery } from '@tanstack/react-query';
import { isNil } from 'lodash';
import { ApiService } from 'api';

export const ALEXANDRIA_COMPANY_SEARCH_QUERY_KEY = 'ALEXANDRIA_COMPANY_SEARCH';

interface AlexandriaSearchParams {
  firmId?: number | null;
  companyId?: number | null;
  // Defaults to the company's own name/website on the backend.
  name?: string;
  enabled?: boolean;
}

// Upstream call, not a local lookup — don't refetch on every remount.
const FIVE_MINUTES_MS = 5 * 60 * 1000;

export const useAlexandriaCompanySearch = ({ firmId, companyId, name, enabled = true }: AlexandriaSearchParams) =>
  useQuery({
    queryKey: [ALEXANDRIA_COMPANY_SEARCH_QUERY_KEY, firmId, companyId, name ?? null],
    queryFn: () =>
      ApiService.apiFirmsDailyNavCompaniesAlexandriaSearchList(String(firmId), String(companyId), undefined, name),
    enabled: enabled && !isNil(firmId) && !isNil(companyId),
    staleTime: FIVE_MINUTES_MS,
    // "Not tracked" is a normal answer and a 502 means upstream is down;
    // retrying either just stalls the UI.
    retry: false,
  });
